// extracted by mini-css-extract-plugin
export default {"langSwitcher":"TakEkJsb_7RPtOsIc3LA","language":"jffV8cltN2jcCuuRsxcL"};